<template>
  <v-menu
    offset-y
    :top="top"
    :bottom="bottom"
    content-class="dropdown-button-menu"
    :close-on-content-click="closeOnContentClick"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        class="float-right px-2"
        :class="buttonClasses"
        :text="text"
        :small="small"
        :block="block"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
      >
        <span v-if="right">{{ buttonText }}</span>
        <v-icon v-if="icon" class="pr-2" x-small v-bind="attrs" :right="right">
          {{ icon }}
        </v-icon>
        <span v-if="!right">{{ buttonText }}</span>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        dense
        @click="$emit('item-selected', item)"
      >
        <v-list-item-icon class="mr-4">
          <EvercamLoadingAnimation
            v-if="item.isLoading"
            size="TwoXl"
            class="pr-2"
          />
          <v-img
            v-else-if="item.logo"
            height="20"
            width="20"
            contain
            :src="item.logo"
          ></v-img>
          <v-icon v-else-if="item.icon" small> {{ item.icon }} </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">{{
            item.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import EvercamLoadingAnimation from "@evercam/shared/components/EvercamLoadingAnimation"

export default {
  name: "DropDownButton",
  components: {
    EvercamLoadingAnimation,
  },
  props: {
    closeOnContentClick: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [
        {
          name: "",
          value: "",
          logo: "",
          icon: "",
        },
      ],
    },
    buttonText: {
      type: String,
      default: "Send to",
    },
    icon: {
      type: String,
      default: "",
    },
    right: {
      type: Boolean,
      default: false,
    },
    buttonClasses: {
      type: String,
      default: "",
    },
  },
}
</script>

<style scoped>
.dropdown-button-menu {
  z-index: 999 !important;
}
</style>
